module.exports = __webpack_public_path__ + "static/media/heavy.670a85c3.svg";